import type {ComponentType} from 'react'
import {connect} from 'react-redux'

import type {State} from '../../../../../../reducers/types'
import {getBuild} from '../../../../../../selectors'

import LogMessageRunningIcon from './LogMessageRunningIcon'
import type {OwnProps, StateProps} from './LogMessageRunningIcon.types'

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const build = getBuild(state, buildId)
  const {status, state: buildState, detachedFromAgent} = build ?? {}
  const green = status == null || status === 'SUCCESS'
  return {
    runningIcon:
      buildState === 'running'
        ? `running${detachedFromAgent === true ? '_detached' : ''}${green ? '_green' : '_red'}`
        : null,
  }
}

export default connect(mapStateToProps, {})(LogMessageRunningIcon) as ComponentType<OwnProps>
